<template>
	<div class="app-close-x" @click="$emit('onClose')">
		<div class="app-close-x-inner hover-effect" @click="$emit('onClose')">
			<SIcon name="close-x" />
		</div>
	</div>
</template>

<script>
export default {
	name: 'AppCloseX',
};
</script>

<style scoped lang="scss">
.app-close-x {
	.app-close-x-inner {
		max-height: 26px;
		max-width: 26px;
		border: 1px solid #e7eaf3;
		border-radius: 100px;

		::v-deep svg {
			circle {
				fill: #f5f7fa;
			}
		}
	}
}
</style>
